import axios from '@/utils/api';

const ticketsQuery = `
  query Tickets(
    $dateStart: String!, 
    $dateFinish: String!,
    $categoryIds: [Int],
    $statusNames: [String],
    $assignedUserIds: [Int]
    ) {
    codebaseTickets (
      filters: { 
        dateStart: $dateStart, 
        dateFinish: $dateFinish, 
        categoryIds: $categoryIds,
        statusNames: $statusNames,
        assignedUserIds: $assignedUserIds
      }
    ) {
      edges {
        node {
          id, 
          ticketId,
          project { permalink },
          summary, 
          status { name, colour }, 
          dateRanges { start, finish },
          category { name },
          assignedUser { firstName, lastName }
        }
      }
    }
  }
`

export default {
  namespaced: true,

  state: {
    tasks: []
  },

  getters: {
    getTasks (state) {
      return state.tasks
    }
  },

  actions: {
    async fetchTasks ({ commit, rootState }, { 
      dateStart, 
      dateFinish, 
      categoryIds, 
      statusNames, 
      assignedUserIds 
    }) {
      
      const response = await axios.post('/', {
        query: ticketsQuery,
        variables: {
          dateStart,
          dateFinish,
          categoryIds,
          statusNames,
          assignedUserIds
        }
      },
      {
        headers: {
          'Authorization': rootState.auth.authToken
        }
      })

      if (response.status === 200) {
        commit('setTasks', response.data.data.codebaseTickets.edges)
      } else {
        throw response.status
      }
    },
  },

  mutations: {
    setTasks(state, tasks) {
      state.tasks = tasks
    }
  }
}